"use client";

import React from "react";

import { useParams, NavLink } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  BreadcrumbLink,
} from "@/components/ui/breadcrumb";
import { ProjectContext, ProjectsMap } from "@/context/project";
import { ChevronLeft } from "lucide-react";

const NextBreadcrumb = ({ hideProject = false }: { hideProject?: boolean }) => {
  const { projectId, appName } = useParams();
  const { projectsMap } = React.useContext(ProjectContext) as {
    projectsMap: ProjectsMap;
  };

  const filteredPaths = [];

  if (projectId && projectsMap[projectId] && !hideProject) {
    const project = projectsMap[projectId];
    filteredPaths.push({
      name: project.name,
      link: `/projects/${projectId}`,
    });
  }

  if (appName) {
    filteredPaths.push({
      name: appName,
      link: `/projects/${projectId}/${appName}`,
    });
  }

  return (
    <div>
      <Breadcrumb>
        <BreadcrumbList>
          {/* {appName && (
            <React.Fragment key={-1}>
              <BreadcrumbItem>
                <BreadcrumbPage className="font-medium text-sm">
                  <BreadcrumbLink asChild>
                    <NavLink to={`/projects/${projectId}`}>
                      <ChevronLeft size={16} />
                    </NavLink>
                  </BreadcrumbLink>
                </BreadcrumbPage>
              </BreadcrumbItem>
            </React.Fragment>
          )} */}
          {filteredPaths.length ? (
            filteredPaths.map(({ name, link }, index) => {
              return (
                <React.Fragment key={index}>
                  <BreadcrumbItem>
                    <BreadcrumbPage className="font-medium text-sm">
                      <BreadcrumbLink asChild>
                        <NavLink to={link}>{name}</NavLink>
                      </BreadcrumbLink>
                    </BreadcrumbPage>
                  </BreadcrumbItem>
                  {filteredPaths.length !== index + 1 && (
                    <BreadcrumbSeparator className="hidden md:block" />
                  )}
                </React.Fragment>
              );
            })
          ) : (
            <BreadcrumbItem>
              <BreadcrumbPage className="font-medium text-sm">
                Pipeline
              </BreadcrumbPage>
            </BreadcrumbItem>
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default NextBreadcrumb;
